// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"747":"9b1a034b","757":"a88c4941","915":"2ab86661"}[chunkId] + ".chunk.js";
};